export const colors = {
  contentOnDarkSubtle: "#ffffffb3",
  componentDailyJackpotDefaultBackground: "rgba(28,29,29,0.85)",
  componentDailyJackpotDefaultContent: "#ffffff",
  componentDailyJackpotUrgentContent: "#ffffff",
  componentDailyJackpotUrgentBackground: "rgba(201,78,8,0.85)",
  componentDailyJackpotUrgentPulseContent: "#ffffff",
  componentDailyJackpotUrgentPulseBackground: "rgba(0,110,149,0.85)",
  componentDailyJackpotJustWonContent: "#ffffff",
  componentDailyJackpotJustWonBackground: "rgba(28,29,29,0.85)",
  componentGameLabelNewContent: "#ffffff",
  componentGameLabelNewBackground: "#D22839",
  componentGameLabelNewBorder: "#EA6875",
  componentGameLabelExclusiveContent: "#ffffff",
  componentGameLabelExclusiveBackground: "#006E95",
  componentGameLabelExclusiveBorder: "#4D9AB5",
  componentGameLabelJackpotContent: "#ffffff",
  componentGameLabelJackpotBackground: "#C94e08",
  componentGameLabelJackpotBorder: "#ef6000",
};